/* No countdown or network calls. Hide activity when the cached count expires. */
if (!customElements.get('szh-cart-activity')) {
  customElements.define('szh-cart-activity', class extends HTMLElement {
    connectedCallback() {
      const delay = Number(this.dataset.expires) - Date.now();
      this.hidden = !Number.isFinite(delay) || delay <= 0;
      if (!this.hidden) this.timeout = setTimeout(() => { this.hidden = true; }, Math.min(delay, 4200000));
    }
    disconnectedCallback() { clearTimeout(this.timeout); }
  });
}
